export const INTERNAL_LINKS = {
  HOME: "/",
  AUTH: {
    SIGN_IN: "/auth/sign-in",
    SIGN_UP: "/auth/sign-up",
  },
  STATUS_PAGE: "https://status.sfcompute.com",
  TRUST_CENTER: "https://trust.sfcompute.com",
  DOCS: {
    HOME: "https://docs.sfcompute.com",
    TOKENS: "https://docs.sfcompute.com/preview/tokens",
    INSTANCE_TYPES: "https://docs.sfcompute.com/preview/instance-skus",
    CLI_INSTALLATION:
      "https://docs.sfcompute.com/preview/quick-start#install-the-cli",
    CLOUD_INIT: "https://docs.sfcompute.com/preview/instances#cloud-init",
    INSTANCES: "https://docs.sfcompute.com/preview/instances",
    INSTANCE_LIFECYCLE:
      "https://docs.sfcompute.com/preview/guides/instances-and-pools#instance-lifecycle",
    FIREWALLS: "https://docs.sfcompute.com/preview/firewalls",
    SUBNETS: "https://docs.sfcompute.com/preview/networking/subnets",
    INFINIBAND_PARTITIONS:
      "https://docs.sfcompute.com/preview/networking/infiniband-partitions",
    LIMITS: "https://docs.sfcompute.com/preview/limits",
    IMAGE_UPLOAD:
      "https://docs.sfcompute.com/preview/images#uploading-an-image",
    IMAGE_REQUIREMENTS:
      "https://docs.sfcompute.com/preview/images#image-requirements",
    IMAGE_EXAMPLE_REPO: "https://github.com/sfcompute/packer_example/",
    POOLS: "https://docs.sfcompute.com/preview/pools",
    MIGRATING_FROM_NODES:
      "https://docs.sfcompute.com/preview/guides/migrating-from-nodes",
  },
  DASHBOARD: {
    HOME: "/dashboard",
    ADMIN: "/dashboard/admin",
    BUY: "/contact",
    CAPACITY: "/dashboard/capacity",
    STATEMENTS: "/dashboard/provider/statements",
    USAGE: "/dashboard/usage",
    BILLING: "/dashboard/billing",
    INSTANCES: "/dashboard/instances",
    IMAGES: "/dashboard/instances/images",
    INSTANCE_TEMPLATES: "/dashboard/instances/instance-templates",
    NETWORKS: "/dashboard/networks",
    SUBNETS: "/dashboard/networks/subnets",
    INFINIBAND_PARTITIONS: "/dashboard/networks/infiniband",
    FIREWALLS: "/dashboard/networks/firewalls",
    STORAGE: "/dashboard/storage",
    TOKENS: "/dashboard/tokens",
    SETTINGS: "/dashboard/settings",
    SUPPORT: "/dashboard/support",
    INSTANCE_TYPES: {
      HOME: "/dashboard/instance-types",
    },
  },
  BUY: "/contact",
  CONTACT: "/contact",
  ABOUT: "/about",
  PRICES: "/prices",
  CHANGELOG: "/changelog",
  BLOG: {
    HOME: "/blog",
  },
  LEGAL: {
    HOME: "/legal",
    TERMS_OF_SERVICE: "/legal/terms-of-service",
    PRIVACY_POLICY: "/legal/privacy-policy",
    DATA_PROCESSING_AGREEMENT: "/legal/dpa",
    ACCEPTABLE_USE_POLICY: "/legal/acceptable-use-policy",
    SERVICE_LEVEL_AGREEMENT: "/legal/sla",
  },
  // Served by sfcompute.com.2026 via the microfrontends `requirements` group.
  REQUIREMENTS: "/requirements",
} as const;

export const EXTERNAL_LINKS = {
  CAL: {
    MISC_MEETING: "https://cal.com/montanashowalter/miscmeeting",
    QUICK_CALL: "https://cal.com/team/sf-compute-team/sfc-introduction",
    TECHNICAL_SUPPORT:
      "https://cal.com/team/sf-compute-team/sfc-technical-support",
  },
  SOCIAL: {
    TWITTER: "https://twitter.com/sfcompute",
  },
  JOBS: {
    HOME: "https://jobs.ashbyhq.com/sfcompute",
  },
  CUSTOMERS: {
    ULTRAVOX: "https://www.ultravox.ai",
    LIQUIDAI: "https://www.liquid.ai",
    MACH9: "https://www.mach9.io",
    ROBOFLOW: "https://roboflow.com",
    DATOLOGY: "https://www.datologyai.com",
    NVIDIA: "https://brev.nvidia.com",
  },
} as const;
